import { sha256 } from "js-sha256";
import { CockpitUser, MekUser } from "./api";
import * as utf8 from "utf8";

export const pushUserInfoTracking = (user: CockpitUser) => {
    if (user.mekUser?.email) {
        window.dataLayer.push({
            event: "userInfo",
            userInfo: {
                userID: sanitizeAndHash(user.crmUser.devNumber),
                partnerCompanyID: sanitizeAndHash(user.crmUser.companyDevNumber),
                accountID: sanitizeAndHash(user.mekUser.email),
            },
        });
    }
};

export const pushUserInfoTrackingControl = (user: MekUser) => {
    if (user.email) {
        window.dataLayer.push({
            event: "userInfo",
            userInfo: {
                role: user.keycloakRoles?.join(",") ?? "",
                username: sanitizeAndHash(user.name ?? ""),
                accountID: sanitizeAndHash(user.email),
            },
        });
    }
};

export function sanitizeAndHash(input: string) {
    const sanitizedInput = utf8.encode(input.trim().toLowerCase());
    return sha256(sanitizedInput);
}
